var b = Object.defineProperty;
var J = (o, t, e) => t in o ? b(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var i = (o, t, e) => J(o, typeof t != "symbol" ? t + "" : t, e);
import { L as u } from "./layout-CEgW1KBl.mjs.js";
import { B as x } from "./base-CMhGIFuX.mjs.js";
import { j as c, c as y } from "./client-BkmPNNjT.mjs.js";
class I extends x {
  constructor() {
    super(...arguments);
    i(this, "apiKey", "");
    i(this, "version");
    i(this, "cioOptions");
    /** Pre filter expressions from Shopify section settings that affects all collections*/
    i(this, "sectionPreFilters", []);
    /** Pre filter expressions from collection metafield that affects specific collection, and overrides sectionPreFilters */
    i(this, "metafieldPreFilters");
    /** Houzz configs for controlling this widget, such as show_filter_pills and show_result_count */
    i(this, "config");
  }
  async connectedCallback() {
    await super.connectedCallback(), this.apiKey = this.dataset.apiKey || "", this.version = this.dataset.version, this.cioOptions = this.getJson("cio-options"), this.sectionPreFilters = this.getJson("section-pre-filters") || [], this.metafieldPreFilters = this.getJson("metafield-pre-filters"), this.config = this.getJson("config");
  }
}
class F extends I {
  constructor() {
    super(...arguments);
    i(this, "categoryIds", []);
    i(this, "productIds", []);
  }
  async connectedCallback() {
    await super.connectedCallback();
    const e = this.dataset.filterName || "group_id", a = this.dataset.filterValue || "all";
    this.categoryIds = this.parseJson(this.dataset.categoryIds) || [], this.productIds = this.parseJson(this.dataset.productIds) || [];
    let s = {
      ...this.cioOptions
    }, n = {
      filterName: e,
      filterValue: a
      // options,
    }, r;
    const p = this.metafieldPreFilters?.pre_filters || [], l = this.metafieldPreFilters?.search_query || "";
    this.categoryIds.length > 0 ? this.categoryIds.length > 1 || l ? r = {
      or: this.categoryIds.map((h) => ({
        name: "current_category_int",
        value: h.toString()
      }))
    } : n = {
      filterName: "group_id",
      filterValue: this.categoryIds[0].toString()
    } : this.productIds.length > 0 && (n = {
      itemIds: this.productIds
    });
    const d = [...this.sectionPreFilters, ...p];
    d.length > 0 && r ? s.preFilterExpression = {
      and: [...d, r]
    } : d.length > 0 ? s.preFilterExpression = {
      and: d
    } : r && (s.preFilterExpression = r);
    const C = {
      apiKey: this.apiKey,
      version: this.version
    }, g = this.getJson("topsort-configuration");
    let f;
    g && (f = {
      apiKey: g.apiKey,
      slots: g.slots,
      categoryId: this.categoryIds?.[0]?.toString()
    });
    let m;
    if (l) {
      const {
        CioSearch: h
      } = await import("./cioSearch-DWiA47pv.mjs.js");
      m = /* @__PURE__ */ c.jsx(h, {
        query: l,
        topsort: f,
        options: s,
        config: this.getJson("config"),
        ...C
      });
    } else {
      const {
        CioBrowse: h
      } = await import("./cioBrowse-BeAC2gcI.mjs.js");
      m = /* @__PURE__ */ c.jsx(h, {
        browsePaths: n,
        topsort: f,
        options: s,
        config: this.getJson("config"),
        ...C
      });
    }
    y.createRoot(this).render(/* @__PURE__ */ c.jsx(u, {
      children: m
    }));
  }
}
customElements.get("cio-browse") || customElements.define("cio-browse", F);
class P extends I {
  async connectedCallback() {
    await super.connectedCallback();
    const {
      CioSearch: t
    } = await import("./cioSearch-DWiA47pv.mjs.js"), e = this.dataset.query || "";
    let a = {
      ...this.cioOptions
    };
    this.sectionPreFilters.length > 0 && (a.preFilterExpression = {
      and: this.sectionPreFilters
    });
    const s = this.getJson("topsort-configuration");
    let n;
    s && (n = {
      apiKey: s.apiKey,
      slots: s.slots
    }), y.createRoot(this).render(/* @__PURE__ */ c.jsx(u, {
      children: /* @__PURE__ */ c.jsx(t, {
        query: e,
        topsort: n,
        options: a,
        apiKey: this.apiKey,
        version: this.version,
        config: this.getJson("config")
      })
    }));
  }
}
customElements.get("cio-search") || customElements.define("cio-search", P);
class w extends x {
  async connectedCallback() {
    await super.connectedCallback();
    const t = this.dataset.apiKey || "", e = this.dataset.version, a = this.dataset.podId || "", s = this.getJson("cio-options"), n = this.getJson("carousel-options");
    if (!t) {
      this.innerHTML = "Constructor API key is required";
      return;
    }
    if (!a) {
      this.innerHTML = "Pod ID is required";
      return;
    }
    const r = {
      autoplay: Number(this.dataset.autoplay),
      css: {
        root: this.dataset.cssRoot,
        content: this.dataset.cssContent,
        item: this.dataset.cssSlide,
        prevBtn: this.dataset.cssPrevBtn,
        nextBtn: this.dataset.cssNextBtn,
        dots: this.dataset.cssDots,
        dot: this.dataset.cssDot
      },
      ...n
    }, p = this.getJson("config"), {
      CioRecommendations: l
    } = await import("./cioRecommendations-BkWBSx7O.mjs.js");
    y.createRoot(this).render(/* @__PURE__ */ c.jsx(u, {
      children: /* @__PURE__ */ c.jsx(l, {
        carouselProps: r,
        podId: a,
        cioOptions: s,
        config: p,
        apiKey: t,
        version: e
      })
    }));
  }
}
customElements.get("cio-recommendations") || customElements.define("cio-recommendations", w);
